export enum TemplateType {
    PANAYA = 'PANAYA',
    CUSTOM = 'CUSTOM'
}

export enum TemplateCategory {
    PANAYA_TEMPLATES = 'Panaya Templates',
    CUSTOM_TEMPLATES = 'Custom Templates'
}

export enum TemplateCategoryOrder {
    CUSTOM = 0,
    PANAYA = 1
}
